// Collection-page background FX — vanilla ports of React Bits <Particles/>
// (raw WebGL, ogl removed) and <LiquidEther/> (three.js global, React removed).
// Same contract as rays.js: one fixed, pointer-transparent, screen-blended
// .mz-rays canvas per page, configured on the <script> tag:
//   data-fx="particles" [data-count data-spread data-speed data-colors data-size]
//   data-fx="liquid"    [data-colors data-force data-cursor ...]  (needs window.THREE)
(function () {
  var s = document.currentScript;
  if (!s || !s.dataset.fx) return;
  var d = s.dataset;
  var isTouch = !matchMedia('(hover: hover) and (pointer: fine)').matches;

  var wrap = document.createElement('div');
  wrap.className = 'mz-rays mz-bgfx';
  wrap.setAttribute('aria-hidden', 'true');
  var host = d.target && document.querySelector(d.target);
  if (host) {                                  // scoped to one section, not the page
    wrap.className += ' mz-rays-local';
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(wrap);
  } else {
    document.body.insertBefore(wrap, document.body.firstChild);
  }

  /* ── PARTICLES ─────────────────────────────────────────────────────── */
  function particles() {
    var canvas = document.createElement('canvas');
    wrap.appendChild(canvas);
    var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false });
    if (!gl) { wrap.remove(); return; }

    var VERT = [
      'attribute vec3 position;attribute vec4 random;attribute vec3 color;',
      'uniform mat4 modelMatrix;uniform mat4 viewMatrix;uniform mat4 projectionMatrix;',
      'uniform float uTime;uniform float uSpread;uniform float uBaseSize;uniform float uSizeRandomness;',
      'varying vec4 vRandom;varying vec3 vColor;',
      'void main(){vRandom=random;vColor=color;',
      'vec3 pos=position*uSpread;pos.z*=10.0;',
      'vec4 mPos=modelMatrix*vec4(pos,1.0);float t=uTime;',
      'mPos.x+=sin(t*random.z+6.28*random.w)*mix(0.1,1.5,random.x);',
      'mPos.y+=sin(t*random.y+6.28*random.x)*mix(0.1,1.5,random.w);',
      'mPos.z+=sin(t*random.w+6.28*random.y)*mix(0.1,1.5,random.z);',
      'vec4 mvPos=viewMatrix*mPos;',
      'gl_PointSize=(uBaseSize*(1.0+uSizeRandomness*(random.x-0.5)))/length(mvPos.xyz);',
      'gl_Position=projectionMatrix*mvPos;}'
    ].join('\n');
    var FRAG = [
      'precision highp float;uniform float uTime;varying vec4 vRandom;varying vec3 vColor;',
      'void main(){vec2 uv=gl_PointCoord.xy;float dd=length(uv-vec2(0.5));',
      'float circle=smoothstep(0.5,0.4,dd)*0.8;',
      'gl_FragColor=vec4(vColor+0.2*sin(uv.yxx+uTime+vRandom.y*6.28),circle);}'
    ].join('\n');

    function sh(t, src) {
      var o = gl.createShader(t); gl.shaderSource(o, src); gl.compileShader(o);
      if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { console.warn('bgfx:', gl.getShaderInfoLog(o)); return null; }
      return o;
    }
    var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) { wrap.remove(); return; }
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    gl.useProgram(prog);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    function hexToRgb(hex) {
      hex = hex.replace('#', '');
      var n = parseInt(hex, 16);
      return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
    }
    var palette = (d.colors || '#FFFFFF,#F4F0E9,#D9D4CA').split(',');
    var count = isTouch ? Math.round(+(d.count || 1000) * 0.35) : +(d.count || 1000);
    var positions = new Float32Array(count * 3);
    var randoms = new Float32Array(count * 4);
    var colors = new Float32Array(count * 3);
    for (var i = 0; i < count; i++) {
      var x, y, z, len;
      do { x = Math.random() * 2 - 1; y = Math.random() * 2 - 1; z = Math.random() * 2 - 1; len = x * x + y * y + z * z; } while (len > 1 || len === 0);
      var r = Math.cbrt(Math.random());
      positions.set([x * r, y * r, z * r], i * 3);
      randoms.set([Math.random(), Math.random(), Math.random(), Math.random()], i * 4);
      var col = hexToRgb(palette[Math.floor(Math.random() * palette.length)]);
      colors.set(col, i * 3);
    }
    function attr(name, data, size) {
      var b = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, b);
      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, name);
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, size, gl.FLOAT, false, 0, 0);
    }
    attr('position', positions, 3);
    attr('random', randoms, 4);
    attr('color', colors, 3);

    var U = {};
    function u(n) { return U[n] || (U[n] = gl.getUniformLocation(prog, n)); }

    // minimal mat4 kit (column-major)
    function perspective(fovDeg, aspect, near, far) {
      var f = 1 / Math.tan(fovDeg * Math.PI / 360);
      var nf = 1 / (near - far);
      return new Float32Array([f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (far + near) * nf, -1, 0, 0, 2 * far * near * nf, 0]);
    }
    function rotXYZ(ax, ay, az, tx, ty) {
      var cx = Math.cos(ax), sx = Math.sin(ax), cy = Math.cos(ay), sy = Math.sin(ay), cz = Math.cos(az), sz = Math.sin(az);
      // R = Rz * Ry * Rx, plus translation for hover drift
      return new Float32Array([
        cz * cy, sz * cy, -sy, 0,
        cz * sy * sx - sz * cx, sz * sy * sx + cz * cx, cy * sx, 0,
        cz * sy * cx + sz * sx, sz * sy * cx - cz * sx, cy * cx, 0,
        tx, ty, 0, 1
      ]);
    }
    var VIEW = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, -(+(d.camera || 20)), 1]);

    var dpr = Math.min(devicePixelRatio || 1, 2);
    var W = 1, H = 1;
    function resize() {
      W = wrap.clientWidth * dpr; H = wrap.clientHeight * dpr;
      canvas.width = W; canvas.height = H;
      canvas.style.width = '100%'; canvas.style.height = '100%';
      gl.viewport(0, 0, W, H);
      gl.useProgram(prog);
      gl.uniformMatrix4fv(u('projectionMatrix'), false, perspective(15, W / H, 0.1, 100));
    }
    addEventListener('resize', resize); resize();

    var mouse = { x: 0, y: 0 };
    var hover = +(d.hover || 0.8);
    if (!isTouch && hover > 0) {
      addEventListener('mousemove', function (e) {
        mouse.x = (e.clientX / innerWidth) * 2 - 1;
        mouse.y = -((e.clientY / innerHeight) * 2 - 1);
      }, { passive: true });
    }

    var speed = +(d.speed || 0.08), elapsed = 0, last = performance.now();
    var visible = !document.hidden;
    document.addEventListener('visibilitychange', function () { visible = !document.hidden; });
    gl.uniformMatrix4fv(u('viewMatrix'), false, VIEW);
    gl.uniform1f(u('uSpread'), +(d.spread || 20));
    gl.uniform1f(u('uBaseSize'), +(d.size || 90) * dpr);
    gl.uniform1f(u('uSizeRandomness'), 1);

    function frame(t) {
      requestAnimationFrame(frame);
      if (!visible) { last = t; return; }
      elapsed += (t - last) * speed; last = t;
      var e = elapsed * 0.001;
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform1f(u('uTime'), e);
      gl.uniformMatrix4fv(u('modelMatrix'), false,
        rotXYZ(Math.sin(elapsed * 0.0002) * 0.1, Math.cos(elapsed * 0.0005) * 0.15, elapsed * 0.00001,
          -mouse.x * hover, -mouse.y * hover));
      gl.drawArrays(gl.POINTS, 0, count);
    }
    requestAnimationFrame(frame);
  }

  /* ── LIQUID ETHER (three.js stable-fluids, React Bits port) ────────── */
  function liquid() {
    if (!window.THREE) { console.warn('bgfx liquid: THREE missing'); wrap.remove(); return; }
    var THREE = window.THREE;
    var colors = (d.colors || '#e1e1e1,#fff4d3,#ffa6d3').split(',');
    var OPT = {
      mouse_force: +(d.force || 14), cursor_size: +(d.cursor || 90),
      isViscous: true, viscous: +(d.viscous || 50),
      iterations_viscous: +(d.iterv || 24), iterations_poisson: +(d.iterp || 24),
      dt: 0.014, BFECC: true, resolution: +(d.resolution || 0.35), isBounce: false
    };
    var AUTO = { speed: +(d.autospeed || 0.6), intensity: +(d.autointensity || 2.6), resumeDelay: 3000, ramp: 600 };

    var w = Math.max(1, wrap.clientWidth), h = Math.max(1, wrap.clientHeight);
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.autoClear = false;
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2));
    renderer.setSize(w, h);
    renderer.domElement.style.cssText = 'width:100%;height:100%;display:block';
    wrap.appendChild(renderer.domElement);

    var data = new Uint8Array(colors.length * 4);
    colors.forEach(function (cst, i) {
      var c = new THREE.Color(cst.trim());
      data[i * 4] = Math.round(c.r * 255); data[i * 4 + 1] = Math.round(c.g * 255);
      data[i * 4 + 2] = Math.round(c.b * 255); data[i * 4 + 3] = 255;
    });
    var paletteTex = new THREE.DataTexture(data, colors.length, 1, THREE.RGBAFormat);
    paletteTex.magFilter = paletteTex.minFilter = THREE.LinearFilter;
    paletteTex.needsUpdate = true;

    var face_vert = 'attribute vec3 position;uniform vec2 px;uniform vec2 boundarySpace;varying vec2 uv;precision highp float;void main(){vec3 pos=position;vec2 scale=1.0-boundarySpace*2.0;pos.xy=pos.xy*scale;uv=vec2(0.5)+(pos.xy)*0.5;gl_Position=vec4(pos,1.0);}';
    var mouse_vert = 'precision highp float;attribute vec3 position;attribute vec2 uv;uniform vec2 center;uniform vec2 scale;uniform vec2 px;varying vec2 vUv;void main(){vec2 pos=position.xy*scale*2.0*px+center;vUv=uv;gl_Position=vec4(pos,0.0,1.0);}';
    var advection_frag = 'precision highp float;uniform sampler2D velocity;uniform float dt;uniform bool isBFECC;uniform vec2 fboSize;uniform vec2 px;varying vec2 uv;void main(){vec2 ratio=max(fboSize.x,fboSize.y)/fboSize;if(isBFECC==false){vec2 vel=texture2D(velocity,uv).xy;vec2 uv2=uv-vel*dt*ratio;vec2 newVel=texture2D(velocity,uv2).xy;gl_FragColor=vec4(newVel,0.0,0.0);}else{vec2 spot_new=uv;vec2 vel_old=texture2D(velocity,uv).xy;vec2 spot_old=spot_new-vel_old*dt*ratio;vec2 vel_new1=texture2D(velocity,spot_old).xy;vec2 spot_new2=spot_old+vel_new1*dt*ratio;vec2 error=spot_new2-spot_new;vec2 spot_new3=spot_new-error/2.0;vec2 vel_2=texture2D(velocity,spot_new3).xy;vec2 spot_old2=spot_new3-vel_2*dt*ratio;vec2 newVel2=texture2D(velocity,spot_old2).xy;gl_FragColor=vec4(newVel2,0.0,0.0);}}';
    var color_frag = 'precision highp float;uniform sampler2D velocity;uniform sampler2D palette;uniform vec4 bgColor;varying vec2 uv;void main(){vec2 vel=texture2D(velocity,uv).xy;float lenv=clamp(length(vel),0.0,1.0);vec3 c=texture2D(palette,vec2(lenv,0.5)).rgb;vec3 outRGB=mix(bgColor.rgb,c,lenv);float outA=mix(bgColor.a,1.0,lenv);gl_FragColor=vec4(outRGB,outA);}';
    var divergence_frag = 'precision highp float;uniform sampler2D velocity;uniform float dt;uniform vec2 px;varying vec2 uv;void main(){float x0=texture2D(velocity,uv-vec2(px.x,0.0)).x;float x1=texture2D(velocity,uv+vec2(px.x,0.0)).x;float y0=texture2D(velocity,uv-vec2(0.0,px.y)).y;float y1=texture2D(velocity,uv+vec2(0.0,px.y)).y;float divergence=(x1-x0+y1-y0)/2.0;gl_FragColor=vec4(divergence/dt);}';
    var externalForce_frag = 'precision highp float;uniform vec2 force;uniform vec2 center;uniform vec2 scale;uniform vec2 px;varying vec2 vUv;void main(){vec2 circle=(vUv-0.5)*2.0;float d=1.0-min(length(circle),1.0);d*=d;gl_FragColor=vec4(force*d,0.0,1.0);}';
    var poisson_frag = 'precision highp float;uniform sampler2D pressure;uniform sampler2D divergence;uniform vec2 px;varying vec2 uv;void main(){float p0=texture2D(pressure,uv+vec2(px.x*2.0,0.0)).r;float p1=texture2D(pressure,uv-vec2(px.x*2.0,0.0)).r;float p2=texture2D(pressure,uv+vec2(0.0,px.y*2.0)).r;float p3=texture2D(pressure,uv-vec2(0.0,px.y*2.0)).r;float div=texture2D(divergence,uv).r;float newP=(p0+p1+p2+p3)/4.0-div;gl_FragColor=vec4(newP);}';
    var pressure_frag = 'precision highp float;uniform sampler2D pressure;uniform sampler2D velocity;uniform vec2 px;uniform float dt;varying vec2 uv;void main(){float step=1.0;float p0=texture2D(pressure,uv+vec2(px.x*step,0.0)).r;float p1=texture2D(pressure,uv-vec2(px.x*step,0.0)).r;float p2=texture2D(pressure,uv+vec2(0.0,px.y*step)).r;float p3=texture2D(pressure,uv-vec2(0.0,px.y*step)).r;vec2 v=texture2D(velocity,uv).xy;vec2 gradP=vec2(p0-p1,p2-p3)*0.5;v=v-gradP*dt;gl_FragColor=vec4(v,0.0,1.0);}';
    var viscous_frag = 'precision highp float;uniform sampler2D velocity;uniform sampler2D velocity_new;uniform float v;uniform vec2 px;uniform float dt;varying vec2 uv;void main(){vec2 old=texture2D(velocity,uv).xy;vec2 new0=texture2D(velocity_new,uv+vec2(px.x*2.0,0.0)).xy;vec2 new1=texture2D(velocity_new,uv-vec2(px.x*2.0,0.0)).xy;vec2 new2=texture2D(velocity_new,uv+vec2(0.0,px.y*2.0)).xy;vec2 new3=texture2D(velocity_new,uv-vec2(0.0,px.y*2.0)).xy;vec2 newv=4.0*old+v*dt*(new0+new1+new2+new3);newv/=4.0*(1.0+v*dt);gl_FragColor=vec4(newv,0.0,0.0);}';

    var W = 1, H = 1;
    function calcSize() {
      W = Math.max(1, Math.round(OPT.resolution * wrap.clientWidth));
      H = Math.max(1, Math.round(OPT.resolution * wrap.clientHeight));
    }
    calcSize();
    var cellScale = new THREE.Vector2(1 / W, 1 / H);
    var fboSize = new THREE.Vector2(W, H);
    var boundarySpace = new THREE.Vector2().copy(cellScale);

    var isIOS = /(iPad|iPhone|iPod)/i.test(navigator.userAgent);
    var fboOpts = {
      type: isIOS ? THREE.HalfFloatType : THREE.FloatType,
      depthBuffer: false, stencilBuffer: false,
      minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter,
      wrapS: THREE.ClampToEdgeWrapping, wrapT: THREE.ClampToEdgeWrapping
    };
    var fbos = {};
    ['vel_0', 'vel_1', 'vel_viscous0', 'vel_viscous1', 'div', 'pressure_0', 'pressure_1'].forEach(function (k) {
      fbos[k] = new THREE.WebGLRenderTarget(W, H, fboOpts);
    });

    var cam = new THREE.Camera();
    function pass(frag, uniforms, output) {
      var scene = new THREE.Scene();
      var mat = new THREE.RawShaderMaterial({ vertexShader: face_vert, fragmentShader: frag, uniforms: uniforms });
      scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), mat));
      return { scene: scene, uniforms: uniforms, output: output, run: function (out) {
        renderer.setRenderTarget(out || this.output || null);
        renderer.render(this.scene, cam);
        renderer.setRenderTarget(null);
      } };
    }

    var advection = pass(advection_frag, {
      boundarySpace: { value: cellScale }, px: { value: cellScale }, fboSize: { value: fboSize },
      velocity: { value: fbos.vel_0.texture }, dt: { value: OPT.dt }, isBFECC: { value: true }
    }, fbos.vel_1);

    var forceScene = new THREE.Scene();
    var forceMat = new THREE.RawShaderMaterial({
      vertexShader: mouse_vert, fragmentShader: externalForce_frag,
      blending: THREE.AdditiveBlending, depthWrite: false,
      uniforms: {
        px: { value: cellScale },
        force: { value: new THREE.Vector2() },
        center: { value: new THREE.Vector2() },
        scale: { value: new THREE.Vector2(OPT.cursor_size, OPT.cursor_size) }
      }
    });
    forceScene.add(new THREE.Mesh(new THREE.PlaneGeometry(1, 1), forceMat));

    var viscousU = {
      boundarySpace: { value: boundarySpace }, velocity: { value: fbos.vel_1.texture },
      velocity_new: { value: fbos.vel_viscous0.texture }, v: { value: OPT.viscous },
      px: { value: cellScale }, dt: { value: OPT.dt }
    };
    var viscousP = pass(viscous_frag, viscousU, fbos.vel_viscous1);
    var divergenceP = pass(divergence_frag, {
      boundarySpace: { value: boundarySpace }, velocity: { value: fbos.vel_viscous0.texture },
      px: { value: cellScale }, dt: { value: OPT.dt }
    }, fbos.div);
    var poissonU = {
      boundarySpace: { value: boundarySpace }, pressure: { value: fbos.pressure_0.texture },
      divergence: { value: fbos.div.texture }, px: { value: cellScale }
    };
    var poissonP = pass(poisson_frag, poissonU, fbos.pressure_1);
    var pressureP = pass(pressure_frag, {
      boundarySpace: { value: boundarySpace }, pressure: { value: fbos.pressure_0.texture },
      velocity: { value: fbos.vel_viscous0.texture }, px: { value: cellScale }, dt: { value: OPT.dt }
    }, fbos.vel_0);

    var outScene = new THREE.Scene();
    var outMat = new THREE.RawShaderMaterial({
      vertexShader: face_vert, fragmentShader: color_frag, transparent: true, depthWrite: false,
      uniforms: {
        velocity: { value: fbos.vel_0.texture },
        boundarySpace: { value: new THREE.Vector2() },
        palette: { value: paletteTex },
        bgColor: { value: new THREE.Vector4(0, 0, 0, 0) }
      }
    });
    outScene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), outMat));

    // pointer: auto-drift until real mouse takes over, resume after idle
    var coords = new THREE.Vector2(), coordsOld = new THREE.Vector2(), diff = new THREE.Vector2();
    var autoCur = new THREE.Vector2(), autoTarget = new THREE.Vector2();
    var lastInteract = 0, autoActive = false, autoStart = 0, lastT = performance.now();
    function pickTarget() {
      autoTarget.set((Math.random() * 2 - 1) * 0.8, (Math.random() * 2 - 1) * 0.8);
    }
    pickTarget();
    if (!isTouch) {
      addEventListener('mousemove', function (e) {
        lastInteract = performance.now();
        autoActive = false;
        coords.set((e.clientX / innerWidth) * 2 - 1, -((e.clientY / innerHeight) * 2 - 1));
      }, { passive: true });
    }

    function simUpdate() {
      var now = performance.now();
      // auto-driver
      if (now - lastInteract > AUTO.resumeDelay) {
        if (!autoActive) { autoActive = true; autoStart = now; autoCur.copy(coords); }
        var dtSec = Math.min((now - lastT) / 1000, 0.2);
        var dir = new THREE.Vector2().subVectors(autoTarget, autoCur);
        var dist = dir.length();
        if (dist < 0.01) pickTarget();
        else {
          dir.normalize();
          var ramp = Math.min(1, (now - autoStart) / AUTO.ramp);
          ramp = ramp * ramp * (3 - 2 * ramp);
          autoCur.addScaledVector(dir, Math.min(AUTO.speed * dtSec * ramp, dist));
          coords.copy(autoCur);
        }
      }
      lastT = now;
      diff.subVectors(coords, coordsOld);
      coordsOld.copy(coords);
      if (autoActive) diff.multiplyScalar(AUTO.intensity);

      advection.uniforms.dt.value = OPT.dt;
      advection.run();

      var csx = OPT.cursor_size * cellScale.x, csy = OPT.cursor_size * cellScale.y;
      forceMat.uniforms.force.value.set((diff.x / 2) * OPT.mouse_force, (diff.y / 2) * OPT.mouse_force);
      forceMat.uniforms.center.value.set(
        Math.min(Math.max(coords.x, -1 + csx + cellScale.x * 2), 1 - csx - cellScale.x * 2),
        Math.min(Math.max(coords.y, -1 + csy + cellScale.y * 2), 1 - csy - cellScale.y * 2)
      );
      renderer.setRenderTarget(fbos.vel_1);
      renderer.render(forceScene, cam);
      renderer.setRenderTarget(null);

      var velOut = fbos.vel_1, fin, fout;
      for (var i = 0; i < OPT.iterations_viscous; i++) {
        fin = i % 2 === 0 ? fbos.vel_viscous0 : fbos.vel_viscous1;
        fout = i % 2 === 0 ? fbos.vel_viscous1 : fbos.vel_viscous0;
        viscousU.velocity_new.value = fin.texture;
        viscousP.run(fout);
      }
      velOut = fout;

      divergenceP.uniforms.velocity.value = velOut.texture;
      divergenceP.run();

      var pin, pout;
      for (var j = 0; j < OPT.iterations_poisson; j++) {
        pin = j % 2 === 0 ? fbos.pressure_0 : fbos.pressure_1;
        pout = j % 2 === 0 ? fbos.pressure_1 : fbos.pressure_0;
        poissonU.pressure.value = pin.texture;
        poissonP.run(pout);
      }

      pressureP.uniforms.velocity.value = velOut.texture;
      pressureP.uniforms.pressure.value = pout.texture;
      pressureP.run();

      renderer.render(outScene, cam);
    }

    function resize() {
      renderer.setSize(Math.max(1, wrap.clientWidth), Math.max(1, wrap.clientHeight));
      calcSize();
      cellScale.set(1 / W, 1 / H);
      fboSize.set(W, H);
      boundarySpace.copy(cellScale);
      for (var k in fbos) fbos[k].setSize(W, H);
    }
    addEventListener('resize', resize);

    var visible = !document.hidden;
    document.addEventListener('visibilitychange', function () { visible = !document.hidden; });
    function frame() {
      requestAnimationFrame(frame);
      if (!visible) return;
      simUpdate();
    }
    requestAnimationFrame(frame);
  }

  if (d.fx === 'particles') particles();
  else if (d.fx === 'liquid') liquid();
})();
